import { Left } from 'Models/Menu/menus';
import { getView, requireAuth } from '@/lib/utils';
import { OrganizationsPage } from '@/data/appInformationItems';

export default {
  path: '/organizations',
  name: 'organizations',
  component: getView('pages/PageOrganizations'),
  beforeEnter: requireAuth,
  meta: {
    crumbs: 'Organizations',
    leftMenu: Left.OrganizationsList,
    roles: ['operator'],
    information: OrganizationsPage,
    showBottomMenu: true,
  },
};
